import state from "./store";
import * as mutations from './mutations';
import * as getters from './getters';
import * as actions from './actions';

const namespaced = true;

export default {
    namespaced,
    actions,
    state,
    mutations,
    getters
}
